// Global Components
import * as React from 'react';
import {
  Col,
  FormGroup,
  Label,
  Row,
} from 'reactstrap';
import {
  AvInput,
} from 'availity-reactstrap-validation';

// Helpers
import _ from 'lodash';
import {
  isDiff,
} from '@vroskus/library-helpers/dist/browser';

// Types
type $OptionalProps = {
  disabled?: boolean;
  label?: string;
  onChange?: (value: null | string) => unknown;
  required?: boolean;
  value?: null | string;
};

type $Props = $OptionalProps & {
  name: string;
};

type $State = {
  value: null | string;
  value1: string;
  value2: string;
};

type $DisassembleValue = (value?: null | string) => {
  value1: string;
  value2: string;
};

const disassembleValue: $DisassembleValue = (value) => {
  if (value) {
    const parts = value.split('-');

    const value1: string = _.get(
      parts,
      '[0]',
      '',
    );

    const value2: string = _.get(
      parts,
      '[1]',
      '',
    );

    return {
      value1,
      value2,
    };
  }

  return {
    value1: '',
    value2: '',
  };
};

class InputNoView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    disabled: undefined,
    label: undefined,
    onChange: undefined,
    required: undefined,
    value: undefined,
  };

  onChange: (value: null | string) => unknown;

  constructor(props: $Props) {
    super(props);

    const {
      value1,
      value2,
    } = disassembleValue(props.value);

    this.state = {
      value: props.value || null,
      value1,
      value2,
    };

    this.onChange = props.onChange ? _.debounce(
      props.onChange,
      1000,
    ) : () => {};
  }

  componentDidUpdate(prevProps: $Props): void {
    const {
      value,
    } = this.props;

    if (isDiff(
      prevProps.value,
      value,
    )) {
      const {
        value1,
        value2,
      } = disassembleValue(value);

      this.setState({
        value: value || null,
        value1,
        value2,
      });
    }
  }

  setValue(params: {
    value1: string;
    value2: string;
  }): void {
    let value: null | string = null;

    if (params.value1 !== '' && params.value2 !== '') {
      value = `${params.value1}-${params.value2}`;
    }

    this.setState({
      value,
      value1: params.value1,
      value2: params.value2,
    });

    this.onChange(value);
  }

  render() {
    const {
      disabled,
      label,
      name,
      required,
    } = this.props;
    const {
      value,
      value1,
      value2,
    } = this.state;

    return (
      <FormGroup className={'InputNo'}>
        {label && (
          <Label>
            {label}
          </Label>
        )}
        <Row>
          <Col
            className={'pr-1'}
            xs={5}
          >
            <AvInput
              disabled={disabled}
              name={`_1${name}`}
              onChange={(e) => this.setValue({
                value1: e.target.value,
                value2,
              })}
              required={required}
              value={value1}
            />
          </Col>
          <Col
            className={'pl-1'}
            xs={7}
          >
            <AvInput
              disabled={disabled}
              name={`_2${name}`}
              onChange={(e) => this.setValue({
                value1,
                value2: e.target.value,
              })}
              required={required}
              value={value2}
            />
          </Col>
        </Row>
        <AvInput
          name={name}
          style={{
            display: 'none',
          }}
          value={value}
        />
      </FormGroup>
    );
  }
}

export default InputNoView;
